var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length > 0
    ? _c(
        "div",
        { staticStyle: { background: "#f3f3f3", padding: "20px 0 20px" } },
        [
          _c("div", { staticClass: "warp" }, [
            _c("div", { staticClass: "title" }, [
              _c("img", {
                staticClass: "titleImg",
                attrs: {
                  src: require("@/assets/images/b2c/xinpin.png"),
                  alt: "",
                  srcset: ""
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "titleName" }, [_vm._v("新品上架")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "shopList" },
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item",
                    on: {
                      click: function($event) {
                        return _vm.toProductDetail(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "itemImg" }, [
                      _c("img", {
                        attrs: { src: item.image, alt: "", srcset: "" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "itemText" }, [
                      _c("div", { staticClass: "itemTitleName" }, [
                        _vm._v(_vm._s(item.productName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-start",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("div", { staticClass: "itemTitlePrice" }, [
                            _vm._v(
                              "\n                            ￥" +
                                _vm._s(Number(item.price).toFixed(2)) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          item.originalPrice
                            ? _c("s", { staticClass: "itemTitlePrice2" }, [
                                _vm._v(
                                  "\n                            原价:￥" +
                                    _vm._s(
                                      Number(item.originalPrice).toFixed(2)
                                    ) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "shopName" }, [
                        _c("img", {
                          staticClass: "shopImg",
                          attrs: { src: item.shopLogo, alt: "", srcset: "" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "shopNameText" }, [
                          _vm._v(_vm._s(item.shopName))
                        ])
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payBtn" }, [
      _c("img", {
        staticClass: "shan",
        attrs: {
          src: require("../../../assets/images/b2c/shan_icon.png"),
          alt: "",
          srcset: ""
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "btn1" }, [_vm._v("销量 100+")]),
      _vm._v(" "),
      _c("div", { staticClass: "btn2" }, [_vm._v("立即购买")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6bde02ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6bde02ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/b2c/index/xinpin.vue
// module id = null
// module chunks = 